import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons';
import {Button} from "react-bootstrap";
import {useState} from "react";
import {Sidebar} from "../components/Sidebar";
import avatar from "../assets/avatar-portfolio.jpeg";
import { useLanguage } from "../context/LanguageContext";

interface HomePageProps {
    isHomeVisible: boolean;
    isSkillsVisible: boolean;
    isPortfolioVisible: boolean;
    isContactVisible: boolean;
    isServicesVisible: boolean;
}

export const HomePage = (props: HomePageProps) => {
    const [showSidebar,setShowSidebar] = useState(false)
    const { t } = useLanguage();

    const visibilityKeys: { [key: string]: keyof typeof props } = {
        Home: 'isHomeVisible',
        Skills: 'isSkillsVisible',
        Services: 'isServicesVisible',
        Portfolio: 'isPortfolioVisible',
        Contact: 'isContactVisible'
    }

    const moveToSection = (id: string) => {
        const element = document.getElementById(id)
        element?.scrollIntoView({
            behavior: 'smooth'
        })
    }
    const arrayButtons = ["Home", "Skills", "Services", "Portfolio", "Contact"]

    return (
        <div>
            <header className="header">
                <div className="logo">
                    <a href="#" onClick={(event) => {
                    event.preventDefault()
                    moveToSection('Home')
                }}>Matias</a>
                    <p>.</p>
                </div>
                <nav className="navbar">
                    <Button className="navbarButton" onClick={()=>setShowSidebar(!showSidebar)}>
                        <FontAwesomeIcon icon={faBars} />
                    </Button>
                    {arrayButtons.map((section) => (
                        <a key={section} href="#" className={props[visibilityKeys[section]] ? 'active' : ''}
                           onClick={(event) => {
                               event.preventDefault()
                               moveToSection(section)
                           }}>{t(`nav.${section.toLowerCase()}`)}</a>
                    ))}
                </nav>
                <Sidebar arrayButtons={arrayButtons} homeProps={props} moveToSection={moveToSection} show={showSidebar}/>
            </header>

            <div className="home">
                <div className="home-content">
                    <div className="hero-text-container">
                        <div className="hero-badges">
                            <span className="hero-badge">✦ {t('home.badge1')}</span>
                            <span className="hero-badge">✦ {t('home.badge2')}</span>
                            <span className="hero-badge">✦ {t('home.badge3')}</span>
                        </div>
                        <h1>{t('home.hi')}</h1>
                        <h3>{t('home.role')}</h3>
                        <p>{t('home.description')}</p>
                    </div>
                    <div className="btn-box">
                        <a href="#" onClick={(event)=>{event.preventDefault()
                            moveToSection("Contact")}}>{t('home.letsTalk')}</a>
                    </div>
                    <div className="home-sci">
                        <a href="https://github.com/matias-norambuena" target="_blank" rel="noreferrer">
                            <i className="bx bxl-github"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/matias-norambuena-55328197/?locale=en_US" target="_blank" rel="noreferrer">
                            <i className="bx bxl-linkedin"></i>
                        </a>
                    </div>
                    <div className="hero-stats">
                        <div className="hero-stat">
                            <span className="stat-number">7</span>
                            <span className="stat-label">{t('stats.years')}<br/><small>{t('stats.yearsLabel')}</small></span>
                        </div>
                        <div className="hero-stat">
                            <span className="stat-number">3</span>
                            <span className="stat-label">{t('stats.countries')}<br/><small>{t('stats.countriesLabel')}</small></span>
                        </div>
                        <div className="hero-stat">
                            <span className="stat-number">{t('stats.stack')}</span>
                            <span className="stat-label"><small>{t('stats.stackLabel')}</small></span>
                        </div>
                        <div className="hero-stat">
                            <span className="stat-number">{t('stats.company')}</span>
                            <span className="stat-label"><small>{t('stats.companyLabel')}</small></span>
                        </div>
                    </div>
                </div>
                <div>
                    <img className="profile-picture" src={avatar} alt="profile-picture"/>
                </div>
            </div>
        </div>
    );
};
